export default __webpack_public_path__ + "static/media/question.6ff47950.svg";